import React, { useEffect, useState } from 'react';

import useRaffles from '../hooks/useRaffles';
import useAuctionHouse from '../hooks/useAuctionHouse';

const AuctionStatusBadge = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);

  const auctionHouse = useAuctionHouse();

  const [auction, setAuction] = useState();
  const [auctionStarted, setAuctionStarted] = useState(false);
  const [auctionEnded, setAuctionEnded] = useState(false);

  useEffect(() => {
    let ignore = false;
    setAuction(null);

    if (raffle && auctionHouse) {
      const fetchAuction = () => {
        auctionHouse.auctions(raffle.auction_id).then((auction) => {
          const [
            _,
            startingPrice,
            startingTime,
            quantity,
            depreciationFactor,
            depreciationInterval,
            bids,
          ] = auction;

          if (!ignore) {
            setAuction({
              startingPrice,
              startingTime: new Date(startingTime * 1000),
              quantity,
              depreciationFactor,
              depreciationInterval,
              bids,
            });
          }
        });
      };

      fetchAuction();
      const bid = auctionHouse.filters.SuccessfulBid(raffle.auction_id);
      auctionHouse.on(bid, fetchAuction);
      return () => {
        auctionHouse.off(bid, fetchAuction);
        ignore = true;
      };
    }
  }, [raffle, auctionHouse]);

  useEffect(() => {
    setAuctionStarted(false);
    setAuctionEnded(false);
    if (auction) {
      const updateAuctionState = () => {
        setAuctionStarted(auction.startingTime.getTime() < Date.now());
        setAuctionEnded(auction.bids >= auction.quantity);
      };
      updateAuctionState();
      const intervalId = setInterval(updateAuctionState, 10000);
      return () => clearInterval(intervalId);
    }
  }, [auction]);

  if (auctionEnded) {
    return <span className="badge rounded-pill bg-secondary">Ended</span>;
  }

  if (auctionStarted) {
    return <span className="badge rounded-pill bg-success">Active</span>;
  }

  return <span className="badge rounded-pill bg-primary">Upcoming</span>;
};

export default AuctionStatusBadge;
